<!-- 工具箱 -->
<template>
  <div class="tool-box-content">
    <div class="tool-tab">
      <span
        :class="['item', proOperate === 1 ? 'active' : '']"
        @click="changeTag(1)"
        >Python+AI模型</span
      >
      <span
        :class="['item', proOperate == 2 ? 'active' : '']"
        @click="changeTag(2)"
        >上传文件</span
      >
    </div>
    <el-tree
      v-show="proOperate === 1"
      :data="toolList"
      :props="defaultProps"
      node-key="blockId"
      @node-click="handleNodeClick"
      :default-expand-all="false"
      :default-expanded-keys="[blockId]"
      :default-checked-keys="[blockId]"
      :highlight-current="true"
      ref="toolTree"
      class="scroll-bar"
    ></el-tree>

    <div class="files-content" v-show="proOperate === 2">
      <!-- 音频文件模块 -->
      <div class="upload-wrap audio-upload">
        <div class="btn-wrap">
          <span class="label">音频</span>
          <span class="upload" @click="uploadFiles('audio', 'audioTempList')"
            >+</span
          >
          <div class="clearfix"></div>
          <el-divider></el-divider>
        </div>
        <ul class="file-list scroll-bar" v-if="audioTempList.length">
          <li
            v-for="item in audioTempList"
            :key="item.mediaId"
            @mouseenter="showDel(item.mediaId)"
            @mouseleave="hideDel"
          >
            <img :src="img.iconAudio" alt="音频" class="media-item" />
            <el-input
              class="name"
              v-model.trim="item.mediaFileName"
              @change="updateMediaBlock(item)"
            />
            <span class="copy-item" @click="copyUrl(item.mediaFileUrl)"
              >复制地址</span
            >
            <img
              :src="img.iconDelete"
              class="delete"
              @click="deleteMediaApi(item)"
              v-show="delId === item.mediaId"
            />
          </li>
        </ul>
      </div>
      <!-- 图片文件模块 -->
      <div class="upload-wrap pic-upload">
        <div class="btn-wrap">
          <span class="label">图片</span>
          <span class="upload" @click="uploadFiles('image', 'picTempList')"
            >+</span
          >
          <div class="clearfix"></div>
          <el-divider></el-divider>
        </div>
        <ul class="file-list scroll-bar" v-if="picTempList.length">
          <li
            v-for="item in picTempList"
            :key="item.mediaId"
            @mouseenter="showDel(item.mediaId)"
            @mouseleave="hideDel"
          >
            <img :src="item.mediaFileUrl" alt="图片" class="media-item" />
            <el-input
              class="name"
              v-model.trim="item.mediaFileName"
              @change="updateMediaBlock(item)"
            />
            <span class="copy-item" @click="copyUrl(item.mediaFileUrl)"
              >复制地址</span
            >
            <img
              :src="img.iconDelete"
              class="delete"
              @click="deleteMediaApi(item)"
              v-show="delId === item.mediaId"
            />
          </li>
        </ul>
      </div>
      <!-- 文本文件模块 -->
      <div class="upload-wrap pic-upload">
        <div class="btn-wrap">
          <span class="label">文本</span>
          <span class="upload" @click="uploadFiles('txt', 'picTempList')"
            >+</span
          >
          <div class="clearfix"></div>
          <el-divider></el-divider>
        </div>
        <ul class="file-list scroll-bar" v-if="textTempList.length">
          <li
            v-for="item in textTempList"
            :key="item.mediaId"
            @mouseenter="showDel(item.mediaId)"
            @mouseleave="hideDel"
          >
            <img :src="img.iconText" alt="文本" class="media-item" />
            <el-input
              class="name"
              v-model.trim="item.mediaFileName"
              @change="updateMediaBlock(item)"
            />
            <span class="copy-item" @click="copyUrl(item.mediaFileUrl)"
              >复制地址</span
            >
            <img
              :src="img.iconDelete"
              class="delete"
              @click="deleteMediaApi(item)"
              v-show="delId === item.mediaId"
            />
          </li>
        </ul>
      </div>
      <!-- 媒体文件模块 -->
      <div class="upload-wrap pic-upload">
        <div class="btn-wrap">
          <span class="label">摄像头</span>
          <span class="upload" @click="openMedia">+</span>
          <div class="clearfix"></div>
          <el-divider></el-divider>
        </div>
        <ul class="file-list scroll-bar" v-if="camTempList.length">
          <li
            v-for="item in camTempList"
            :key="item.mediaId"
            @mouseenter="showDel(item.mediaId)"
            @mouseleave="hideDel"
          >
            <img :src="img.iconMedia" alt="媒体" class="media-item" />
            <el-input
              class="name"
              v-model.trim="item.mediaFileName"
              @change="updateMediaBlock(item)"
            />
            <span class="copy-item" @click="copyUrl(item.mediaFileUrl)"
              >复制地址</span
            >
            <img
              :src="img.iconDelete"
              class="delete"
              @click="deleteMediaApi(item)"
              v-show="delId === item.mediaId"
            />
          </li>
        </ul>
      </div>

      <!-- 实现复制文本  -->
      <input
        id="copy_content"
        type="text"
        value=""
        style="position: absolute;top: 0;left: 0;opacity: 0;z-index: -10;"
      />
    </div>

    <div class="popup-list list-2">
      <!-- 新建摄像头弹框功能 -->
      <popup-media
        :popupActive.sync="popupActive"
        @confirmNetCamera="confirmNetCamera"
      ></popup-media>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import PYTHON from '@/axios/personalSpace/AiEditor/python.js'
import COMMON from '@/axios/common/common.js'
//实训接口
import BLOCK from '@/axios/trainingCenter/AiEditor/blocks.js'
//项目接口
import AI_EDITOR from '@/axios/personalSpace/AiEditor/blocks.js'
//引入图片路径
import { iconAudio, iconMedia, iconText, iconDelete } from '@/utils/images.js'
import { GetVerifyImgs } from '@/assets/js/mixin/mixinGetVerifyImgs.js'

import popupMedia from '@/components/blocklyEditor/common/PopupMedia.vue'
export default Vue.extend({
  mixins: [GetVerifyImgs],
  components: { popupMedia },
  props: {
    Media: {
      type: Array,
      default() {
        return []
      },
    },
    trainingId: {
      type: String,
      default: '',
    },
    projectId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      toolList: [],
      audioTempList: [],
      picTempList: [],
      camTempList: [],
      textTempList: [],
      proOperate: 1,
      defaultProps: {
        children: 'children',
        label: 'blockName',
      },
      blockId: '',
      popupActive: '',
      firstMount: false,
      document: null,
      img: {
        iconAudio: iconAudio,
        iconMedia: iconMedia,
        iconText: iconText,
        iconDelete: iconDelete,
      },
      pic_match: /.jpeg|.png|.jpg|.svg/i,
      audio_match: /.WMA|.mp3|.wav|.wma|.ape|.flac|.ogg|.aac|.m4a/i,
      text_match: /.txt/i,
      m3u8_match: /^http:\/\/.*m3u8$/,
      delId: null,
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 新UC头像基地址（代理）
      fileBaseUrl: window.gtaAiConfig.fileBaseUrl, // 新UC头像基地址
    }
  },
  computed: {
    ...mapGetters(['accountInfo']),
  },
  watch: {
    toolList(list) {
      let blockId
      if (this.toolList.length && this.firstMount) {
        blockId = this.toolList[0].children[0].blockId
        if (this.firstMount) {
          this.firstMount = false
        }
        this.blockId = blockId
        // console.log('this.blockId', this.blockId)
        this.getCodeBlockInfoByIdApi(blockId)
      }
    },
    blockId(val) {
      console.log('val', val)
    },
    Media: {
      handler(Media) {
        let self = this,
          reg_base_url = new RegExp(this.photoBaseUrl),
          mediaFiles =
            Media.length > 0
              ? Media.map((item) => {
                  return {
                    mediaFileUrl: item.mediaFileUrl,
                    mediaFileName: item.mediaFileName,
                    mediaId: item.mediaId,
                  }
                })
              : [],
          picTempList = [],
          camTempList = [],
          audioTempList = [],
          textTempList = []

        if (Media.length < 0) {
          return
        }

        mediaFiles.forEach(function(file) {
          let pic_match = self.pic_match
          let audio_match = self.audio_match
          let text_match = self.text_match
          let m3u8_match = self.m3u8_match
          // console.log('m3u8_match', m3u8_match)
          if (file && file.mediaFileUrl) {
            // 图片列表
            let mediaFileUrl = file.mediaFileUrl
            if (pic_match.test(mediaFileUrl)) {
              file.mediaFileUrl = self.photoBaseUrl + mediaFileUrl
              picTempList.push(file)
            }
            //摄像头列表
            if (mediaFileUrl.search(/(rtsp|rtmp):/) != -1 || m3u8_match.test(mediaFileUrl)) {
              camTempList.push(file)
            }
            // 音频列表
            if (audio_match.test(mediaFileUrl)) {
              file.mediaFileUrl = self.photoBaseUrl + mediaFileUrl
              audioTempList.push(file)
            }
            // 文本列表
            if (text_match.test(mediaFileUrl)) {
              file.mediaFileUrl = self.photoBaseUrl + mediaFileUrl
              textTempList.push(file)
            }
          }
        })
        this.picTempList = picTempList
        this.camTempList = camTempList
        this.audioTempList = audioTempList
        this.textTempList = textTempList
      },
      deep: true,
      immediate: true,
    },
  },
  async created() {
    await this.getCodeBlockListApi()
    this.firstMount = true
  },
  mounted() {},
  methods: {
    changeTag(val) {
      this.proOperate = val
    },
    openMedia() {
      this.popupActive = 'camera'
    },
    //创建摄像头
    confirmNetCamera(netCamera) {
      var mediaFileName = netCamera.name || '摄像头'
      mediaFileName = mediaFileName.replace(/,/, '')
      mediaFileName = mediaFileName.replace(/，/, '')
      var mediaFileUrl = netCamera.url
      this.mediaUpload([
        {
          mediaFileName: mediaFileName,
          mediaFileUrl: mediaFileUrl,
        },
      ])
    },
    uploadFiles(fileName, arrName) {
      let self = this,
        inputNode = document.createElement('input')
      inputNode.setAttribute('type', 'file')
      inputNode.setAttribute('multiple', 'true')
      if (fileName === 'txt') {
        inputNode.setAttribute('accept', `.txt`)
      } else {
        inputNode.setAttribute('accept', `${fileName}/*`)
      }
      let pic_match = this.pic_match
      let audio_match = this.audio_match
      let text_match = this.text_match
      inputNode.onchange = function uploadImg(evt) {
        // 获取 file
        let fileList = evt.target.files,
          list = Array.from(fileList),
          formatPass

        if (list.length > 20) {
          return self.$message({
            message: '单次上传不可超过20个文件哦！',
            type: 'error',
            duration: 2000,
          })
        }

        if (fileName === 'txt') {
          formatPass = self.$util.filesFormatEveryCheck(list, text_match)
          if (!formatPass) {
            self.$message({
              message: '上传失败，请上传txt文件！',
              type: 'error',
              duration: 2000,
            })
            return
          }
        } else if (fileName === 'image') {
          formatPass = self.$util.filesFormatEveryCheck(list, pic_match)
          if (!formatPass) {
            self.$message({
              message: '上传失败，请上传图片！',
              type: 'error',
              duration: 2000,
            })
            return
          }
        } else if (fileName === 'audio') {
          formatPass = self.$util.filesFormatEveryCheck(list, audio_match)
          if (!formatPass) {
            self.$message({
              message: '上传失败，请上传音频！',
              type: 'error',
              duration: 2000,
            })
            return
          }
        }

        const loading = self.$loading({
          lock: true,
          text: '上传中请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        setTimeout(() => {
          loading.close() // 超过60秒时关闭loading效果
        }, 1000 * 60)

        //过滤特殊字符
        let formdata = new FormData()
        list.forEach((file) => {
          formdata.append('file', file)
        })
        COMMON.UploadMultipleFile(formdata).then((result) => {
          if (result && result.returnCode == 200 && result.data) {
            let imgList = result.data;
            let arr = []
            if (fileName === 'image') {
              if (imgList.length === 0) {
                return loading.close()
              }
              // 校验图片jpg|jpeg
              self.verifyImgs(imgList).then(res => {
                if (res.correct && res.correct.length) {
                  res.correct.forEach(i => {
                    imgList.forEach(j => {
                      if (i.fileUrl.indexOf(`${j.url}`) !== -1) {
                        arr.push({
                          mediaFileName: j.fileName,
                          mediaFileUrl: j.url,
                        })
                      }
                    });
                  });
                  self.mediaUpload(arr)
                }
              })
            } else {
              imgList.forEach((item) => {
                arr.push({
                  mediaFileName: item.fileName,
                  mediaFileUrl: item.url,
                })
              })
              self.mediaUpload(arr)
            }
            loading.close()
          } else {
            loading.close()
          }
        })
        .catch((err) => {
          loading.close()
        })
      }
      inputNode.click()
    },
    // 提交媒体图片上传接口
    async mediaUpload(mediaList) {
      let { trainingId, accountInfo, projectId } = this,
        result,
        data = {}
      data.mediaList = mediaList
      if (trainingId) {
        //实训中心的调用
        data.trainingId = trainingId
        data.userId = accountInfo.userId
        result = await BLOCK.insertMedia(data)
      } else if (projectId) {
        data.projectId = projectId
        console.log('data', data)
        result = await AI_EDITOR.insertMedia(data)
      } else {
        return
      }
      if (result.returnCode == 200) {
        this.$emit('getMedia')
        this.mediaGotten = 1 //代表上传了数据
      } else {
        this.$message.error('媒体变量上传失败!')
      }
    },
    copyUrl(url) {
      // 处理代理字段 service_photoDomain
      url = url.indexOf('service_photoDomain') !== -1 ? (this.fileBaseUrl + url.split('service_photoDomain')[1]) : url;
      var inputElement = document.getElementById('copy_content')
      inputElement.value = url
      inputElement.select()
      document.execCommand('Copy')
      this.$message.success('复制成功')
    },
    //修改媒体积木接口
    async updateMediaBlock(renameObj) {
      var self = this,
        data,
        res
      // console.log('renameObj', renameObj)
      data = {
        mediaId: renameObj.mediaId,
        mediaFileName: renameObj.mediaFileName,
      }
      if (this.trainingId) {
        res = await BLOCK.updateMedia(data)
      } else {
        res = await AI_EDITOR.updateMedia(data)
      }
      if (res && res.returnCode == 200) {
        this.$message.success('名称修改成功')
      } else {
        this.$message.error(res.returnMsg)
      }
    },
    showDel(index) {
      this.delId = index
    },
    hideDel() {
      this.delId = null
    },
    deleteMediaApi(item) {
      let data = {
        mediaId: item.mediaId,
        mediaFileName: item.mediaFileName,
      }
      if (this.trainingId) {
        //实训中心编辑器的逻辑删除api
        BLOCK.deleteMedia(data).then((result) => {
          if (result && result.isSuccess) {
            this.$emit('getMedia')
            this.$message.success('文件删除成功')
          } else {
            reject(result)
            this.$message.error(res.returnMsg)
          }
        })
      } else {
        //AI-T编辑器的删除api
        AI_EDITOR.deleteMedia(data).then((result) => {
          if (result && result.isSuccess) {
            this.$emit('getMedia')
            this.$message.success('文件删除成功')
          } else {
            reject(result)
            this.$message.error(res.returnMsg)
          }
        })
      }
    },
    handleNodeClick(data) {
      //没有数据时不调用
      if (!data || !data.blockId) return
      //点击目录时不调用
      if (data.children && data.children.length) return
      //调用获取文档详情
      this.getCodeBlockInfoByIdApi(data.blockId)
      //显示文档
      this.$emit('showHandler', true)
    },

    /**
     * 查询代码模式的积木菜单
     * @params null
     */
    getCodeBlockListApi() {
      PYTHON.getCodeBlockList()
        .then((res) => {
          if (res && res.isSuccess) {
            this.toolList = this.treeHandler(res.data)
          } else {
            this.toolList = []
            // console.log(res)
          }
        })
        .catch((err) => console.log(err))
    },

    /**
     * 根据积木id查询积木菜单详情
     * @params blockId 积木id
     */
    getCodeBlockInfoByIdApi(blockId) {
      let data = {
        blockId,
      }
      PYTHON.getCodeBlockInfoById(data)
        .then((res) => {
          if (res && res.isSuccess) {
            this.document = res.data
            let blockContent = res.data.blockContent
            // console.log('blockContent', blockContent)
            if (!blockContent) blockContent = ''
            this.$emit('getDocument', blockContent)
          } else {
            console.log(res)
          }
        })
        .catch((err) => console.log(err))
    },

    //处理成树形数据结构
    treeHandler(list) {
      let listSort = this.listSortHandler(list)
      //  构造树
      let arr = []
      listSort.forEach((item) => {
        item.children = []
        if (parseInt(item.parentId) == 0) {
          arr.push(item)
        } else {
          this.iterated(arr, item)
        }
      })
      return arr
    },
    //排序
    listSortHandler(list) {
      let listSort = list.sort((prev, next) => {
        if (parseInt(prev.blockLevel) - parseInt(next.blockLevel) != 0) {
          return prev.blockLevel - next.blockLevel
        } else {
          return parseInt(prev.blockOrder) - parseInt(next.blockOrder)
        }
      })
      return listSort
    },
    //迭代器
    iterated(arr, obj) {
      if (!arr || !arr.length) return //跳出迭代
      let isChild = false
      arr.forEach((item2) => {
        if (obj.parentId == item2.blockId) {
          isChild = true
          return item2.children.push(obj) //跳出循环
        } else {
          this.iterated(item2.children, obj) //迭代
        }
      })
    },
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
})
</script>
<style lang="scss" scoped>
@mixin inner-tree-node-bg($bg) {
  background-image: linear-gradient(to right, from($bg), to(transparent));
}
@mixin inner-tree($icon, $linear_bg, $focus_color) {
  &.is-expanded {
    > .el-tree-node__content {
      background-image: linear-gradient(
        to right,
        lighten($linear_bg, 0.8),
        transparent
      );
    }
  }
  .is-current {
    > .el-tree-node__content {
      color: $focus_color;
      .el-tree-node__expand-icon {
        &::before {
          background: $focus_color;
          // transform: translateX(10px);
        }
      }
    }
  }
  > .el-tree-node__content {
    .el-tree-node__label {
      &:after {
        content: '';
        display: inline-block;
        width: 0;
        height: 0;
        border-left: 3px solid transparent;
        border-right: 3px solid transparent;
        border-top: 6px solid #fff;
        margin: 0px 0 0 8px;
        transform: rotate(-90deg) translateX(2px);
        transition: all 0.5s;
      }
    }
    .expanded + span {
      &:after {
        transform: rotate(0deg);
        transition: all 0.5s;
      }
    }
    .el-tree-node__expand-icon {
      &::before {
        content: '';
        background: $icon 100% 100%;
        background-size: 100% auto;
        display: inline-block;
        width: 15px;
        height: 15px;
        transform: translateX(10px);
      }
    }
  }
}

.tool-box-content {
  width: 220px;
  background-color: rgba(21, 35, 76, 1);
  font-size: 14px;
  height: 100%;
  border-right: 2px solid rgba(74, 224, 226, 0.1);
  // height: calc(100% -80px);
  // margin-bottom: 20px;
  // overflow: auto;
  .tool-tab {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .item {
      display: inline-block;
      width: 110px;
      height: 30px;
      line-height: 30px;
      border: none;
      color: #fff;
      font-size: 14px;
      text-align: center;
      background: rgba(52, 84, 164, 0.3);
      cursor: pointer;
      &.active {
        // background: none;
        background: #3454a4;
        border: none;
      }
    }
  }

  /deep/.el-tree {
    background: none;
    color: #d8dff4;
    font-size: 14px;
    margin: 0;
    padding-bottom: 30px;
    height: 95.4%;
    overflow: auto;
    box-sizing: border-box;
    .el-tree-node {
      // margin-top: 10px;
      padding: 5px 0;
    }
    &.el-tree--highlight-current > .el-tree-node {
      // padding-left: 20px;
      // margin-top: 24px;
      margin-top: 14px;
    }
    &.el-tree--highlight-current
      .el-tree-node.is-current
      > .el-tree-node__content {
      background-color: rgba(255, 255, 255, 0);
      //  color: red !important;
    }

    .el-tree-node {
      &:hover {
        > .el-tree-node__content {
          background-color: rgba(255, 255, 255, 0);
        }
      }
      &:focus {
        > .el-tree-node__content {
          background-color: rgba(255, 255, 255, 0);
        }
      }
    }

    .el-tree-node__content {
      padding: 0 0 0 20px;
      .el-tree-node__expand-icon {
        &::before {
          content: '';
          background-size: 100% auto;
          display: inline-block;
          font-size: 38px;
          background: #fff;
          width: 4px;
          height: 4px;
          border-radius: 2px;
          transform: translateX(20px);
        }
        &.expanded {
          transform: rotate(0deg);
        }
        &.is-leaf::before {
          display: none;
        }
      }
      .el-tree-node__label {
        margin-left: 20px;
      }
    }

    &.el-tree--highlight-current {
      > div[role='treeitem']:nth-child(1) {
        @include inner-tree(
          url('../../../../../public/images/editor/icon-resume.png'),
          rgba(31, 202, 133, 0.6),
          rgba(31, 202, 133, 1)
        );
      }
      > div[role='treeitem']:nth-child(2) {
        @include inner-tree(
          url('../../../../../public/images/editor/icon_python_base.png'),
          #5a238d,
          #d322ff
        );
      }
      > div[role='treeitem']:nth-child(3) {
        @include inner-tree(
          url('../../../../../public/images/editor/icon-my-model.png'),
          rgba(245, 66, 66, 0.6),
          #f54242
        );
      }
      > div[role='treeitem']:nth-child(4) {
        @include inner-tree(
          url('../../../../../public/images/editor/icon-base-model.png'),
          rgba(106, 195, 11, 0.6),
          rgba(106, 195, 11, 1)
        );
      }
      > div[role='treeitem']:nth-child(5) {
        @include inner-tree(
          url('../../../../../public/images/editor/icon-advace-model.png'),
          rgba(31, 202, 133, 0.6),
          rgba(31, 202, 133, 1)
        );
      }
      > div[role='treeitem']:nth-child(6) {
        @include inner-tree(
          url('../../../../../public/images/editor/icon-hardware.png'),
          rgba(88, 176, 243, 0.6),
          rgba(88, 176, 243, 1)
        );
      }
    }
  }

  .files-content {
    width: 100%;
    height: calc(100% - 50px);
    box-sizing: border-box;
    background-color: rgba(21, 35, 76, 1);
    padding: 10px 6px 0px 6px;
    .upload-wrap {
      // width: 100%;
      // min-height: 200px;
      height: 23%;
      margin: 4% 0 0 0;
      color: #fff;
      .label {
        display: block;
        float: left;
      }
      .upload {
        display: block;
        float: right;
        margin-right: 5px;
        font-size: 20px;
        padding: 0 5px;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        background: rgba(110, 158, 255, 1);
      }
      .file-list {
        width: 100%;
        border: 1px solid #203163;
        padding: 8px 5px;
        box-sizing: border-box;
        // height: 140px;
        height: calc(100% - 40px);
        overflow: auto;

        li {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: start;
          // &:hover {
          // }
        }
        img {
          display: inline-block;
          width: 16px;
          height: 16px;
        }
        /deep/.el-input {
          display: inline-block;
          width: 88px;
          margin-left: 5px;
          .el-input__inner {
            background: none;
            border: none;
            outline: none;
            color: #fff;
            height: 28px;
            padding: 0 5px;
            &:focus {
              background: rgba(255, 255, 255, 0.1);
            }
          }
        }
        span {
          margin: 0 5px;
          &.copy-item {
            display: inline-block;
            cursor: pointer;
            margin: 0px;
            &:hover {
              color: rgba(255, 255, 255, 0.7);
            }
          }
        }
        .delete {
          width: 14px;
          height: 14px;
          margin: 2px 0 0 8px;
          cursor: pointer;
        }
      }

      .el-divider--horizontal {
        width: auto;
        margin: 8px 5px 8px 0;
        background: #203163;
        &::after {
          width: 35px;
          height: 2px;
          content: '';
          display: inline-block;
          position: absolute;
          z-index: 9;
          bottom: 0px;
          background: #6e9eff;
        }
      }
    }
  }
}
</style>
